import React from "react";
import "./tags.scss";

interface Props {
  tags: string[];
  className?: string;
}

export const Tags = ({ tags, className }: Props) => {
  return (
    <div className={`tags ${className}`}>
      {tags &&
        tags.map((item, i) => (
          <div key={i} className="tag">
            {item}
          </div>
        ))}
    </div>
  );
};
